import { render, staticRenderFns } from "./place-card.vue?vue&type=template&id=526226fa"
import script from "./place-card.vue?vue&type=script&lang=ts"
export * from "./place-card.vue?vue&type=script&lang=ts"
import style0 from "./place-card.vue?vue&type=style&index=0&id=526226fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports